import { Component } from '@angular/core';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';

@Component({
  selector: 'app-aggiornamento-massivo-disclaimer',
  templateUrl: './aggiornamento-massivo-disclaimer.component.html',
  styleUrls: ['./aggiornamento-massivo-disclaimer.component.css']
})
export class AggiornamentoMassivoDisclaimerComponent {

  constructor(
    private dialogRef : DialogRef
  ) { }

  onAction(event: boolean) {
    this.dialogRef.close({modalEvent : event});
  }

}
